import { ADMIN_CODE, MEMBER_CODE } from "constants/constants";

const DefinedRoleId = ({ role_id, showMember }) => {
  switch (role_id) {
    case MEMBER_CODE:
      if (showMember) return "MEMBER";
      return null;
    case ADMIN_CODE:
      return "ADMIN";
    default:
      return "";
  }
};

export default DefinedRoleId;
